import React from 'react';
import './App.css';
import Homepage from './pages/home'; 
import Layout from './components/layout'; 
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import About from './pages/about';
import ServicesPage from './pages/service';
import ContactPage from './pages/contact';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
      <Layout>
         <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/AboutUs" element={<About />} />
          <Route path="/Service" element={<ServicesPage />} />
          <Route path='/Contact' element={<ContactPage/>}/>
        </Routes>
      </Layout>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
